import { render } from "./ListCategories.vue?vue&type=template&id=47c7a614"
import script from "./ListCategories.vue?vue&type=script&lang=js"
export * from "./ListCategories.vue?vue&type=script&lang=js"
script.render = render

export default script